<template>
  <div class="mobile alumni-directory-div">
    <div class="search">
      <van-search
        v-model="keywords"
        shape="round"
        @input="search"
        placeholder="搜索"
      />
    </div>
    <div class="alumni-directory-main" v-if="dataList.length > 0">
      <div
        class="alumni-directory-list"
        v-for="(item, index) in dataList"
        :key="'alumnidirectorylist' + index"
      >
        <div class="alumni-directory-list-head-teacher" v-if="item.isTeacher == 1">
          {{item.title || ""}}
        </div>
        <div class="alumni-directory-list-head-group" v-else>{{item.title || ""}}</div>
        <div class="alumni-directory-list-content">
          <div
            class="alumni-directory-list-item"
            v-for="(tempInfo, tempIndex) in item.alumniBooks"
            :key="'alumnidirectorylistitem' + tempIndex"
            :class="
              (item.alumniBooks.length % 2 > 0 && tempIndex >= item.alumniBooks.length - 1) ||
                (item.alumniBooks.length % 2 == 0 && tempIndex >= item.alumniBooks.length - 2)
                ? 'last-item'
                : 'normal-item'
            "
          >
            <van-image
              :class="
                tempIndex % 2 > 0 ? 'item-image-right' : 'item-image-left'
              "
              lazy-load
              :src="tempInfo.photo | imgFormat"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error>
                <img
                  :src="defaultImg | imgFormat"
                  style="width: 100%; height: 100%"
                />
              </template>
            </van-image>
            <div class="item-infocontent">
              <div class="item-name van-ellipsis">{{tempInfo.name || ""}}</div>
              <div class="item-phone van-ellipsis">{{tempInfo.phone || ""}}</div>
              <div class="item-detail van-ellipsis">{{tempInfo.job || ""}}</div>
            </div>
          </div>
          <div class="alumni-directory-list-line"></div>
        </div>
      </div>
    </div>
    <div class="alumni-directory-main" v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileAlumniDirectory",
  ctrlCaption: "同学录",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      dataList: [],
      keywords: "",
      defaultImg: dsf.config.setting_public_user_default_header,
    };
  },
  props: {
    url: {
      type: String,
      default: "classes/getStuAlumniBookByClassId",
    },
  },
  created() {},
  mounted() {
    if(this.isDesign){
      this.dataList = [
        {
            "isTeacher":1,
            "alumniBooks":[
                {
                    "id":"4869183fbf0a4decbb23b40b4f9dfc17",
                    "name":"金",
                    "phone":"12345678910",
                    "photo":null,
                    "job":null
                }
            ],
            "title":"班主任"
        },
        {
            "isTeacher":0,
            "alumniBooks":[
                {
                    "id":"58eadf81dbb64aab91c506b07219a8d5",
                    "name":"付雪梅111",
                    "phone":"12345678910",
                    "photo":null,
                    "job":null
                }
            ],
            "title":"第三小组"
        }];
        this.$dispatch("design-width-change", "100%");
    }else{
      this.loadCurrentData();
    }
  },
  computed: {},
  methods: {
    search: _.debounce(function () {
      this.loadCurrentData();
    }, 300),
    loadCurrentData() {
      if(this.isDesign){
        return;
      }
      const loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get(this.url, {
          keyWord: this.keywords,
        })
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            _this.dataList = res.data || [];
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
  },
});
</script>